import Quill from 'quill';
import AdvancedLink from '@/components/texteditor/advanced/blots/advancedLinkInline';
import QuillEventBus, { QuillEvents } from '@/components/texteditor/event-bus';
import AdvancedLinkMenu from '@/components/texteditor/advanced/components/AdvancedLinkMenu';

// Emite el evento que muestra el menú con la información del AdvancedLink clickado y presente en el editor
class AdvancedLinkModule {
  constructor(quill, options) {
    this.quill = quill;
    this.listen();
  }

  listen() {
    this.quill.on(Quill.events.SELECTION_CHANGE, (range) => {
      if (range == null) {
        return;
      }

      const [link] = this.quill.scroll.descendant(
        AdvancedLink,
        range.index,
      );

      if (!link) {
        return;
      }

      const domNode = link.domNode;
      const bounds = domNode.getBoundingClientRect();
      const value = JSON.parse(domNode.dataset.value);

      const message = {
        uuid: this.quill.uuid,
        params: {
          component: AdvancedLinkMenu,
          props: {
            position: { x: bounds.x + (bounds.width / 2), y: bounds.y + bounds.height },
            value,
          },
        },
      };
      // mágico, sin el timeout no se levanta el tooltip
      setTimeout(() => {
        QuillEventBus.$emit(QuillEvents.BLOT_SELECTED, message);
      });
    });
  }
}

export default AdvancedLinkModule;
